import { useState, useEffect } from 'react'

/**
 * Hook to detect if the user is on a mobile device
 * Checks screen width, touch capability, and user agent
 */
export const useIsMobile = (): boolean => {
  const [isMobile, setIsMobile] = useState(() => {
    // Initial check on mount
    return checkIsMobile()
  })

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(checkIsMobile())
    }

    // Listen for window resize events
    window.addEventListener('resize', handleResize)

    // Listen for orientation change on mobile devices
    window.addEventListener('orientationchange', handleResize)

    return () => {
      window.removeEventListener('resize', handleResize)
      window.removeEventListener('orientationchange', handleResize)
    }
  }, [])

  return isMobile
}

/**
 * Check if device is mobile based on multiple factors
 */
function checkIsMobile(): boolean {
  // Check 1: Screen width (mobile breakpoint at 768px)
  const isMobileWidth = window.innerWidth < 768

  // Check 2: Touch capability
  const hasTouchScreen =
    'ontouchstart' in window ||
    navigator.maxTouchPoints > 0

  // Check 3: User agent detection (fallback)
  const mobileUserAgentRegex = /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i
  const isMobileUserAgent = mobileUserAgentRegex.test(navigator.userAgent)

  // Consider it mobile if:
  // - Screen is small AND has touch, OR
  // - User agent indicates mobile device
  return (isMobileWidth && hasTouchScreen) || isMobileUserAgent
}
